import { render, staticRenderFns } from "./SimpleThresholdPanelDialog.vue?vue&type=template&id=15799176&scoped=true&"
import script from "./SimpleThresholdPanelDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleThresholdPanelDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimpleThresholdPanelDialog.vue?vue&type=style&index=0&id=15799176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15799176",
  null
  
)

export default component.exports